import React, { useEffect, useState } from "react";
import axios from "axios";
import "../CSS/ProfileAdmin.css";

function ProfileAdmin() {
  // Ambil data admin dari localStorage (hasil login)
  const adminObj = JSON.parse(localStorage.getItem("admin"));
  const adminId = adminObj?.id_admin;

  const [adminData, setAdminData] = useState(null);
  const [editMode, setEditMode] = useState(false);
  const [formData, setFormData] = useState({});

  // Ambil data admin dari backend
  useEffect(() => {
    if (!adminId) return;

    const fetchAdmin = async () => {
      try {
        const res = await axios.get(`https://api-tibismart.tifpsdku.com/api/admin/${adminId}`);
        setAdminData(res.data);
        setFormData({
          nama_lengkap_admin: res.data.nama_lengkap_admin || "",
          username_admin: res.data.username_admin || "",
          nomor_telepon_admin: res.data.nomor_telepon_admin || "",
          email_admin: res.data.email_admin || "",
          foto_admin: res.data.foto_admin || ""
        });
      } catch (err) {
        console.error(err);
        alert("Gagal mengambil data admin!");
      }
    };

    fetchAdmin();
  }, [adminId]);

  if (!adminData) return <p>Loading...</p>;

  // Handle perubahan input
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  // Simpan perubahan ke backend
  const handleSave = async () => {
    try {
      await axios.put(`https://api-tibismart.tifpsdku.com/api/admin/${adminId}`, formData);
      setAdminData({ ...adminData, ...formData });
      setEditMode(false);
      alert("Profile berhasil disimpan!");
    } catch (err) {
      console.error(err);
      alert("Gagal menyimpan profile!");
    }
  };

  return (
    <div className="profile-page">
      <div className="main-content">
        <div className="profile-content">

          {/* Profile Card */}
          <div className="profile-card">
            <div className="profile-avatar">
              {formData.foto_admin
                ? <img 
                    src={formData.foto_admin} 
                    alt="Foto Admin" 
                    width={80} 
                    height={80} 
                    style={{ borderRadius: '50%' }}
                  /> 
                : "AD"
              }
            </div>
            <div className="profile-info">
              <h3>{formData.nama_lengkap_admin}</h3>
              <p>Admin</p>
              <p className="profile-id">ID: {adminData.id_admin}</p>
            </div>
          </div>

          {/* Info Form */}
          <div className="profile-form">

            <div className="form-row">
              <div className="form-group">
                <label>Nama Lengkap</label>
                <input 
                  type="text" 
                  name="nama_lengkap_admin"
                  value={formData.nama_lengkap_admin} 
                  onChange={handleChange} 
                  readOnly={!editMode} 
                />
              </div>
              <div className="form-group">
                <label>Email</label>
                <input 
                  type="email"
                  name="email_admin"
                  value={formData.email_admin} 
                  onChange={handleChange} 
                  readOnly={!editMode} 
                />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>No. Telepon</label>
                <input 
                  type="text" 
                  name="nomor_telepon_admin"
                  value={formData.nomor_telepon_admin} 
                  onChange={handleChange} 
                  readOnly={!editMode} 
                />
              </div>
              <div className="form-group">
                <label>ID Admin</label>
                <input type="text" value={adminData.id_admin} readOnly />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group full">
                <label>Username</label>
                <input 
                  type="text" 
                  name="username_admin"
                  value={formData.username_admin} 
                  onChange={handleChange} 
                  readOnly={!editMode} 
                />
              </div>
            </div>

            {/* Tombol Edit / Save / Batal */}
            {!editMode ? (
              <button className="edit-btnprof" onClick={() => setEditMode(true)}>
                Edit Profile
              </button>
            ) : (
              <div className="edit-buttons">
                <button className="edit-btnprof" onClick={handleSave}>
                  Simpan Perubahan
                </button>
                <button className="edit-btnprof cancel-btn" onClick={() => setEditMode(false)}>
                  Batal
                </button>
              </div>
            )}

          </div>

          <footer className="footerprofile">
            © 2025 TibiSmart. All rights reserved.
          </footer>

        </div>
      </div>
    </div>
  );
}

export default ProfileAdmin;
